export default {
    registerMapEventsHandlers: (map, eventHandler) => {
        map.on('dragend', eventHandler);
        map.on('zoomend', eventHandler);
        map.on('pitchend', eventHandler);
    },

    deregisterMapEventsHandlers: (map, eventHandler) => {
        map.off('dragend', eventHandler);
        map.off('zoomend', eventHandler);
        map.off('pitchend', eventHandler);
    }
};



// WEBPACK FOOTER //
// ./map/tier/trafficIncidentCommons.js